var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 855,
    height: 323,
    viewBox: "0 0 855 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_8526)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M0.5 261.289H150.146V316.093H213.171V261.289H251.838V208.464H213.171V4.31854H130.66L0.5 209.377V261.289ZM151.364 208.464H66.8739V206.028L148.928 76.1729H151.364V208.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M426.575 322.944C504.975 322.944 552.32 263.268 552.472 160.51C552.624 58.5138 504.671 0.0559998 426.575 0.0559998C348.327 0.0559998 300.83 58.3615 300.678 160.51C300.373 262.964 348.022 322.792 426.575 322.944ZM426.575 268.292C390.8 268.292 367.66 232.365 367.813 160.51C367.965 89.7217 390.952 54.099 426.575 54.099C462.045 54.099 485.185 89.7217 485.185 160.51C485.337 232.365 462.198 268.292 426.575 268.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M603.329 261.289H752.975V316.093H816V261.289H854.667V208.464H816V4.31854H733.489L603.329 209.377V261.289ZM754.193 208.464H669.703V206.028L751.757 76.1729H754.193V208.464Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_8526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854.167,
    height: 322.888,
    fill: "white",
    transform: "translate(0.5 0.0559998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg404);
export default __webpack_public_path__ + "static/media/bg-404.23a0ede294d545c816a90266c7b42f81.svg";
export { ForwardRef as ReactComponent };